// eslint-disable-next-line no-undef
export function setClientInterval(title: string, handler: TimerHandler, timeout?: number): number | undefined {
    if (!process.client) {
        console.log(`[INTERVAL_ON_SERVER] !! setClientInterval for '${title}'`);
        return undefined;
    }
    return setInterval(handler, timeout);
}
